import { getAllRegions } from "@/api/area";
import { myCartableAreas } from "@/api/jahadgar";
import { getJahadgarDashboard } from "@/api/user";
import { RegisterAsGroupIcon } from "@/assets";
import CalendarIcon24 from "@/assets/SVG/calendarIcon24";
import LocationIcon from "@/assets/SVG/locationIcon24";
import NewUsersIcon24 from "@/assets/SVG/newUsersIcon24";
import TripIcon2 from "@/assets/SVG/TripIcon2";
import TripIcon24 from "@/assets/SVG/TripIcon24";
import Badge from "@/components/badge/Badge";
import Card from "@/pages/admin/dashboard/components/Card";
import {
  Box,
  Button,
  Grid,
  Tab,
  Tabs,
  Typography,
  useMediaQuery,
} from "@mui/material";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Modal } from "../../modal";
import DashboardArea2 from "../dashboardArea2";
import AreaReport from "./AreaReport";
import JahadgarStats from "./JahadgarStats";
import TripsTable from "./TripsTable";

const styleSelected = {
  fontSize: "16px !important",
  color: "white !important",
  backgroundColor: "var(--emr-darkblue) !important",
  cursor: "pointer",
  transition: "0.2s all",
  borderRadius: "8px !important",
  padding: "4px 8px !important",
};
const styleNotSelected = {
  fontSize: "14px !important",
  color: "var(--emr-disable) !important",
  cursor: "pointer",
  transition: "0.2s all !important",
};

export default function DashboardArea({ role }) {
  const md = useMediaQuery("(max-width:450px)");

  const navigate = useNavigate();
  const [trips, setTrips] = useState([]);

  const [activeTripsStats, setActiveTripsStats] = useState([]);
  const [totalReceptedByMe, setTotalReceptedByMe] = useState(0);
  const [data, setData] = useState();

  useEffect(() => {
    if (role) {
      if (role.hasActiveRegion) {
        getAllRegions()
          .then((x) => setData(x))
          .catch(() => {});
      } else {
        myCartableAreas()
          .then((x) => setData(x))
          .catch(() => {});
      }
    }
  }, [role]);

  useEffect(() => {
    getJahadgarDashboard().then((res) => {
      setTrips(res.trips);

      if (res.activeCartable) {
        if (res.activeCartable.totalReceptedByMe)
          setTotalReceptedByMe(res.activeCartable.totalReceptedByMe);
        if (
          res.activeCartable.activeTrips &&
          res.activeCartable.activeTrips.length > 0
        )
          setActiveTripsStats(res.activeCartable.activeTrips);
      }
    });
  }, []);

  const [selectedTab, setSelectedTab] = useState("jahadgar");

  return (
    <>
      <Tabs
        value={selectedTab}
        onChange={(_, newValue) => {
          setSelectedTab(newValue);
        }}
        sx={{
          backgroundColor: "var(--emr-background-silver)",
          padding: "6px 12px",
          borderRadius: "8px",
          overflow: "auto",
          mt: "10px",
          "& .MuiTabs-indicator": {
            bgcolor: "white",
          },
          "& .MuiTabs-flexContainer": {
            overflow: "auto",
          },
        }}
      >
        <Tab
          label="اطلاعات شخصی"
          value={"jahadgar"}
          sx={selectedTab === "jahadgar" ? styleSelected : styleNotSelected}
          onClick={() => setSelectedTab("jahadgar")}
        />
        {((activeTripsStats &&
          activeTripsStats.length > 0 &&
          activeTripsStats.find((itr) => itr.isOwner)) ||
          (data && data.length > 0 && data[0].cityId === undefined)) && (
          <Tab
            label="مدیریت اردو جاری"
            value={"manageTrip"}
            sx={selectedTab === "manageTrip" ? styleSelected : styleNotSelected}
            onClick={() => setSelectedTab("manageTrip")}
          />
        )}
        {activeTripsStats &&
          activeTripsStats.length > 0 &&
          activeTripsStats.find((itr) => itr.isOwner) && (
            <Tab
              label="رصد اردو جاری"
              value={"reportCurrentTrip"}
              sx={
                selectedTab === "reportCurrentTrip"
                  ? styleSelected
                  : styleNotSelected
              }
              onClick={() => setSelectedTab("reportCurrentTrip")}
            />
          )}
      </Tabs>
      {selectedTab === "jahadgar" && (
        <Grid display={"flex"} flexDirection={"column"} gap={"10px"}>
          <Grid
            display={"flex"}
            flexDirection={md ? "column" : "row"}
            gap={"10px"}
            alignItems={"start"}
          >
            <Grid
              display={"flex"}
              flexDirection={"column"}
              height={"stretch"}
              justifyContent={"space-between"}
            >
              <Badge level={role.level} />
              <Card
                title={"کل مراجعین پذیرش شده شما"}
                icon={<NewUsersIcon24 />}
                counter={totalReceptedByMe}
                width="400px"
                unit={"نفر"}
              />
            </Grid>
            <Modal
              titleVariant="body2"
              title={"اردوهای شما"}
              icon={<RegisterAsGroupIcon />}
              width={md ? "100%" : "calc(100% - 420px)"}
            >
              {trips && <TripsTable trips={trips} />}
            </Modal>
          </Grid>
          {activeTripsStats &&
            activeTripsStats.length > 0 &&
            activeTripsStats.find((itr) => itr.moduleStats.length > 0) && (
              <JahadgarStats activeTripsStats={activeTripsStats} />
            )}
        </Grid>
      )}

      {selectedTab === "manageTrip" &&
        ((activeTripsStats &&
          activeTripsStats.length > 0 &&
          activeTripsStats.find((itr) => itr.isOwner)) ||
          (data && data.length > 0 && data[0].cityId === undefined)) && (
          <>
            {data && role?.hasActiveRegion && (
              <>
                {data[0]?.areas[0]?.cityId ? (
                  <DashboardArea2 data={data} />
                ) : (
                  <Box display="flex" gap="15px">
                    {data?.map((x, index) => (
                      <Modal
                        key={index}
                        icon={<TripIcon24 />}
                        title={"پروژه"}
                        width="calc(min(100%, 500px))"
                      >
                        <Grid
                          display={"flex"}
                          flexDirection={"column"}
                          gap={"15px"}
                          mt={"20px"}
                        >
                          <Grid
                            display={"flex"}
                            justifyContent={"space-between"}
                          >
                            <Grid
                              display={"flex"}
                              alignItems={"center"}
                              gap={"5px"}
                            >
                              <TripIcon2 />
                              <Typography color={"text.primary"}>
                                نام اردو
                              </Typography>
                            </Grid>
                            <Typography color={"text.primary"}>
                              {x.name}
                            </Typography>
                          </Grid>
                          {x.areas?.length >= 1 &&
                            x.areas?.map((item, index) => (
                              <Grid
                                key={index}
                                display={"flex"}
                                flexDirection={"column"}
                                gap={"10px"}
                              >
                                <Grid
                                  display={"flex"}
                                  justifyContent={"space-between"}
                                >
                                  <Grid
                                    display={"flex"}
                                    alignItems={"center"}
                                    gap={"5px"}
                                  >
                                    <LocationIcon />
                                    <Typography color={"text.primary"}>
                                      نام منطقه
                                    </Typography>
                                  </Grid>
                                  <Typography color={"text.primary"}>
                                    {item.name}
                                  </Typography>
                                </Grid>
                              </Grid>
                            ))}
                          {x.startAt && (
                            <Grid
                              display={"flex"}
                              justifyContent={"space-between"}
                            >
                              <Grid
                                display={"flex"}
                                alignItems={"center"}
                                gap={"5px"}
                              >
                                <CalendarIcon24 />
                                <Typography color={"text.primary"}>
                                  بازه برگزاری
                                </Typography>
                              </Grid>
                              <Typography color={"text.primary"}>
                                {`${x.startAt.split(" ", 2)[0]} - ${
                                  x.endAt.split(" ", 2)[0]
                                } `}
                              </Typography>
                            </Grid>
                          )}
                          <Button
                            onClick={() =>
                              navigate(`/complete-area/${x.areas[0]?.id}`)
                            }
                            sx={{ marginTop: "20px" }}
                            width={"100%"}
                            variant="contained"
                          >
                            ساخت منطقه
                          </Button>
                        </Grid>
                      </Modal>
                    ))}
                  </Box>
                )}
              </>
            )}
          </>
        )}
      {selectedTab === "reportCurrentTrip" &&
        activeTripsStats &&
        activeTripsStats.length > 0 &&
        activeTripsStats.find((itr) => itr.isOwner) && (
          <AreaReport activeTripsStats={activeTripsStats} />
        )}
    </>
  );
}
